import {Injectable, EventEmitter} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ItemsService} from 'app/commons/items.service';

@Injectable({
    providedIn: 'root'
})
export class UsersService  extends ItemsService{
    
    public httpEmetteur: EventEmitter<{}>;
    
    user : any;

    constructor(private http2: HttpClient) {
        super(http2);
        this.httpEmetteur = new EventEmitter();
    }
    
    getServiceName(){
        return 'user';
    }

    getRoles() {
        return this.http2.get<any>(ItemsService.API_URL+'role')
            .toPromise()
            .then(res => <any[]> res);
    }

}
